import { tokens } from '../../theme';
import { useMediaQuery } from '../useMediaQuery/useMediaQuery';

export function useIsDesktop(): boolean {
  return useMediaQuery(`(min-width: ${tokens.breakpoint.desktop}px)`);
}
